import * as user from './user'
export default Object.assign({}, user)